import { Outlet, useLocation } from '@tanstack/react-router';
import { Header } from '@/app/layout/header.tsx';
import { Toaster } from '@/components/ui/sonner.tsx';
import GlobalLoader from '@/components/app/global-loader.tsx';
import { TopSearchDrawer } from '@/app/layout/top-search-drawer.tsx';
import { useEffect } from 'react';
import { setPageTitle } from '@/stores/ui.store.ts';
import { Footer } from '@/app/layout/footer.tsx';
import { useVersionReload } from '@/hooks/use-version-reload.ts';
import { GlobalConfirm } from '@/components/app/global-confirm.tsx';

export function Layout() {
  const location = useLocation();
  useVersionReload();
  useEffect(() => {
    setPageTitle();
  }, [location.pathname]);
  return (
    <>
      <TopSearchDrawer />
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
      <Toaster position="top-center" />
      <GlobalLoader />
      <GlobalConfirm />
    </>
  );
}
